import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json";
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import notify from 'devextreme/ui/notify';
import SelectBox from "devextreme-react/select-box";
import Item from "./BareRootPickListItem";
import Field from "./BareRootPickListField";

import PlugCellTypeListItem from "./PlugCellTypeListItem";
import PlugCellTypeListField from "./PlugCellTypeListField";

import ArrayStore from 'devextreme/data/array_store';
import * as Constants from "../../../const/constants";
import NumberBox from 'devextreme-react/number-box';
import { Lookup, DropDownOptions } from 'devextreme-react/lookup';
import { createStore } from 'devextreme-aspnet-data-nojquery';

let _accessToken = '';
const lookup = React.createRef();
var skipOnChangeEvent = false;

class PlugCalculator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specCode: '',
            seedItem: '',
            seedLot: '',
            germ: 0,
            txtPurity:0,
            seedsLb: 0,
            seedsRcvLb: 0,
            cellTypeList: [],
            cellTypeSelectedVal: '',
            orderQty: 0,
            pad: 0,
            overSow: 0,
            seedCell: 0,
            required: 0
        };
        
        this.accessToken = props.oidc.user.access_token;
        this.onValueChangedPickLstSlctBx = this.onValueChangedPickLstSlctBx.bind(this);
        this.onValueChangedCellTypeLstSlctBx = this.onValueChangedCellTypeLstSlctBx.bind(this);
        this.calculateBareRoot = this.calculateBareRoot.bind(this);
        this.onClickClear = this.onClickClear.bind(this);
        this.emailBareRoot = this.emailBareRoot.bind(this);

        this.onSeedSpecCodeValueChanged = this.onSeedSpecCodeValueChanged.bind(this);
        this.onSeeditemValueChanged = this.onSeeditemValueChanged.bind(this);
        this.onSeedLotValueChanged = this.onSeedLotValueChanged.bind(this);
        this.onSeedGermValueChanged = this.onSeedGermValueChanged.bind(this);
        this.onSeedPurityValueChanged = this.onSeedPurityValueChanged.bind(this);
        this.onSeedsLBsValueChanged = this.onSeedsLBsValueChanged.bind(this);
        this.onSeedsOrdrQtyValueChanged = this.onSeedsOrdrQtyValueChanged.bind(this);
        this.onSeedsOverSowValueChanged = this.onSeedsOverSowValueChanged.bind(this);
        this.onSeedsCellValueChanged = this.onSeedsCellValueChanged.bind(this);
        this.onSeedsRequiredValueChanged = this.onSeedsRequiredValueChanged.bind(this);

        _accessToken = props.oidc.user.access_token;
        this.LstPick_plug = createStore({
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.BareRootCalculator.GetBareRootData}`,
            onBeforeSend: function(method, ajaxOptions) {
              ajaxOptions.headers = {
                Authorization: `Bearer ${_accessToken}`
              };
            }
          });
    }
    resetState(){
        skipOnChangeEvent = true;
        lookup.current.instance().option("value", null);
        skipOnChangeEvent = false;
        this.setState({
            specCode: '',
            seedItem: '',
            seedLot: '',
            germ: 0,
            txtPurity:0,
            seedsLb: 0,
            seedsRcvLb: 0,
            cellTypeList: [],
            cellTypeSelectedVal: '',
            orderQty: 0,
            pad: 0,
            overSow: 0,
            seedCell: 0,
            required: 0
        });
    }
    onClickClear(){
        this.resetState();
    }
    emailBareRoot() {
        var email = Constants.CalcSeedQtyEmailToAddress;
        var subject = 'Seed Requirement';
        var emailBody = `Based on your request for ${this.state.orderQty} seedlings for item ${this.state.seedItem} with an oversow of ${this.state.overSow} we need to acquire ${this.state.required} pounds of seed. %0D%0A %0D%0A Item = ${this.state.seedItem} %0D%0A Lot = ${this.state.seedLot} %0D%0A Germ = ${this.state.germ} %0D%0A Purity = ${this.state.txtPurity} %0D%0A Seeds perLb = ${this.state.seedsLb} %0D%0A OverSow = ${this.state.overSow} %0D%0A`;
        document.location = "mailto:" + email + "?subject=" + subject + "&body=" + emailBody;
    }
    calculateBareRoot() {
        let mCellsToSow = this.state.orderQty * this.state.overSow;
        let txtRequired = Number(((((mCellsToSow * this.state.seedCell) * this.state.pad) / this.state.seedsRcvLb)).toFixed(2));
        this.setState({
            required: txtRequired
        });
    }

    loadCelltypeData() {
        var obj = { keyCode: this.state.specCode, germ: this.state.germ }
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.PlugCalculator.GetPlugCellTypeData}`, obj,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: this.accessToken,
                },
            }
        ).then((res) => {
            if (res.data) {
                this.setState({
                    cellTypeList: res.data
                });
            }
        }).catch((err) => {
            console.log('error in LoadCelltypeData');
        });
    }
    getSeedsPerLbsVal(seedsPerLbs, purity) {
        return Math.floor(seedsPerLbs * (purity / 100));
    }
    onValueChangedPickLstSlctBx(e) {

        if(!skipOnChangeEvent)
        {
            axios.get (
                `${window._env_.REACT_APP_APIS}/${routes.BareRootCalculator.GetBareRootRowData}?rowid=${e.value}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: this.accessToken,
                    },
                }
            )
            .then((res) => {
                const obj = res.data;
                if (obj != null && obj != "") {
                    var purty = obj.purity == null || obj.purity == "" ? 95 : obj.purity;
                    this.setState({
                        specCode: obj.seeditemcd,
                        seedItem: obj.seeditem,
                        seedLot: obj.seedlot,
                        germ: obj.germ,
                        seedsLb: obj.seedslb,
                        txtPurity: parseInt(purty),
                        seedsRcvLb: obj.seedslb == null || obj.seedslb == "" ? 0 : parseInt(obj.seedslb * (purty / 100))
                    });
                    this.loadCelltypeData();
                }
            })
            .catch((err) => {
                console.log(err, "error in Getting pick list row");
            });
        }
    }
    onValueChangedCellTypeLstSlctBx(e) {
        const obj = this.state.cellTypeList.filter(x => x.rowid == e.value);
        if (obj.length > 0) {
             const keyCode = obj[0]?.keyCode || ""; 
             const mid = keyCode.length >= 6 ? keyCode.substring(3, 6) : "";
            this.setState({
                seedCell: obj[0].seedsPerCell,
                cellTypeSelectedVal:mid
            });
        }
    }
    onSeedSpecCodeValueChanged(e) {
        if (e.event) {
            this.setState({
                specCode: e.value
            });
        }
    }
    onSeeditemValueChanged(e) {
        if (e.event) {
            this.setState({
                seedItem: e.value
            });
        }
    }
    onSeedLotValueChanged(e) {
        if (e.event) {
            this.setState({
                seedLot: e.value
            });
        }
    }
    onSeedGermValueChanged(e) {
        if (e.event) {
            this.setState({
                germ: e.value
            });
            this.loadCelltypeData();
            notify({
                message: 'Germ Value Changed. Please Reselect Cell Type.',
                width: 200,
              }, 'success', 2000);
        }
    }
    onSeedPurityValueChanged(e) {
        if (e.event) {
            var purity = e.value;
            var seedslb = this.state.seedsLb;
            this.setState({
                seedsRcvLb: this.getSeedsPerLbsVal(seedslb, purity),
                txtPurity: purity,
            });
        }
    }
    onSeedsLBsValueChanged(e) {
        if (e.event) {
            var seeds = e.value;
            var purity = this.state.txtPurity;
            this.setState({
                seedsRcvLb: this.getSeedsPerLbsVal(seeds, purity),
                seedsLb: seeds
            });
        } 
    }
    onSeedsOrdrQtyValueChanged(e) {
        let mTrayType = '';
        let mDirectSow = false;
        let mSpeciesCode = '';
        let mOrderQty = 0;

        mTrayType = this.state.cellTypeSelectedVal;
        mSpeciesCode = this.state.specCode;
        mOrderQty = e.value;

        if (mTrayType == "PS1" || mTrayType == "PS2")
            mDirectSow = false;
        else
            mDirectSow = true;
        if (e.event) {
            this.setState({
                orderQty: e.value,
                pad: this.getSowPad(mSpeciesCode, mDirectSow, mOrderQty)
            });
        }
    }
    onSeedsOverSowValueChanged(e) {
        if (e.event) {
            this.setState({
                overSow: e.value
            });
        }
    }

    onSeedsCellValueChanged(e) {
        if (e.event) {
            this.setState({
                seedCell: e.value
            });
        }
    }
    onSeedsPKTreesValueChanged(e) {
        if (e.event) {
            this.setState({
                pkTreesLb: e.value
            });
        }
    }
    onSeedsRequiredValueChanged(e) {
        if (e.event) {
            this.setState({
                required: e.value
            });
        }
    }
    getSowPad(strSpeciesCode, bolDirectSow, intOrderQty) {
        let mPad = 1.01;

        if (strSpeciesCode == "01" && bolDirectSow) {
            if (intOrderQty < 50000)
                mPad = 1.05;
            if (intOrderQty >= 50000 && intOrderQty < 150000)
                mPad = 1.03;
            if (intOrderQty >= 150000)
                mPad = 1.02;
        }
        if (strSpeciesCode == "01" && (!bolDirectSow))
            mPad = 1.02;
        if (strSpeciesCode == "02" || strSpeciesCode == "18" || strSpeciesCode == "03") {
            if (intOrderQty < 100000)
                mPad = 1.3;
            if (intOrderQty >= 100000 && intOrderQty < 200000)
                mPad = 1.2;
            if (intOrderQty >= 200000)
                mPad = 1.15;
        }
        return mPad;
    }
    render() {
        return (
            <div>
                        <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Calculator Plug
                        </h6>
                      </div>
                <div className="row bg-color">
                    <div className="col-md-6">
                        <Lookup
                            ref={lookup}
                            dataSource={this.LstPick_plug}
                            placeholder="Select Pick List"
                            valueExpr="rowid"
                            onValueChanged={this.onValueChangedPickLstSlctBx}
                            displayExpr= "bareRootPickList"
                            searchEnabled={true}
                        >
                            <DropDownOptions hideOnOutsideClick={true} />
                        </Lookup>
                    </div>
                    <div className="col-md-6 mt-2">
                        <Button
                            width={120}
                            text="Clear"
                            type="default"
                            stylingMode="contained"
                            onClick={this.onClickClear}
                        />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Spec Code:</span>
                        <TextBox
                            value={this.state.specCode}
                            onValueChanged={this.onSeedSpecCodeValueChanged} />
                    </div>
                    <div className="col-md-4 p-lkup-0">
                        <span>Cell Type:</span>
                        <Lookup
                            items={this.state.cellTypeList}
                            placeholder="Select Cell Type"
                            valueExpr="rowid"
                            onValueChanged={this.onValueChangedCellTypeLstSlctBx}
                            itemRender={PlugCellTypeListItem}
                            fieldRender={PlugCellTypeListField}
                            searchEnabled={true}
                            searchExpr={['keyCode']}
                        >
                            <DropDownOptions hideOnOutsideClick={true} />
                        </Lookup>
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Seed Item:</span>
                        <TextBox
                            value={this.state.seedItem}
                            onValueChanged={this.onSeeditemValueChanged} />
                    </div>
                    <div className="col-md-4">
                        <span>Order Qty:</span>
                        <NumberBox
                            format="#,###"
                            value={this.state.orderQty}
                            onValueChanged={this.onSeedsOrdrQtyValueChanged} />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Seed Lot:</span>
                        <TextBox
                            value={this.state.seedLot}
                            onValueChanged={this.onSeedLotValueChanged} />
                    </div>
                    <div className="col-md-4">
                        <span>Pad:</span>
                        <NumberBox
                            value={this.state.pad}
                            onValueChanged={this.onSeedsOverSowValueChanged} />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Germ:</span>
                        <NumberBox
                            value={this.state.germ}
                            onValueChanged={this.onSeedGermValueChanged} />
                    </div>
                    <div className="col-md-4">
                        <span>Over Sow:</span>
                        <NumberBox
                            value={this.state.overSow}
                            onValueChanged={this.onSeedsOverSowValueChanged} />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Purity:</span>
                        <NumberBox value={this.state.txtPurity}
                            onValueChanged={this.onSeedPurityValueChanged} />
                    </div>
                    <div className="col-md-4">
                        <span>Seed-Cell:</span>
                        <NumberBox
                            value={this.state.seedCell}
                            onValueChanged={this.onSeedsCellValueChanged} />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Seeds - LB:</span>
                        <NumberBox
                            format="#,###"
                            value={this.state.seedsLb}
                            onValueChanged={this.onSeedsLBsValueChanged} />
                    </div>
                    <div className="col-md-4">
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <span>Revised - S/LB:</span>
                        <NumberBox
                            format="#,###"
                            value={this.state.seedsRcvLb}
                            readOnly={true} />
                    </div>
                    <div className="col-md-4">
                        <span>Required:</span>
                        <NumberBox
                            value={this.state.required}
                            readOnly={true}
                        />
                    </div>
                </div>
                <div className="row bg-color pt-3">
                    <div className="col-md-4">
                        <Button
                            text="Calculate"
                            type="default"
                            onClick={this.calculateBareRoot}
                        ></Button>
                    </div>
                    <div className="col-md-4">
                        <Button
                            text="Email"
                            type="default"
                            onClick={this.emailBareRoot}
                        ></Button>
                    </div>
                </div>
            </div>
        )
    }
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PlugCalculator);